/* Marcel Afters, G3b collection behaviour (5 Oct 2026). No dependencies.
   - facet chips: one panel open at a time, outside tap / Escape closes, changes apply on their own (Apply button hidden once JS runs)
   - "Show more" is an explicit choice so footer navigation stays reachable (the link still works without JS) */
(function () {
  if (window.__mxColl) return; window.__mxColl = 1;
  document.documentElement.classList.add('mx-js');

  function closeAll(except) {
    [].forEach.call(document.querySelectorAll('details[data-mx-fc][open]'), function (d) { if (d !== except) d.removeAttribute('open'); });
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d || !d.matches || !d.matches('details[data-mx-fc]')) return;
    if (d.open) closeAll(d);
  }, true);
  document.addEventListener('click', function (e) {
    var bd = e.target.closest && e.target.closest('[data-mx-fc-close]');
    if (bd) { closeAll(); return; }
    if (!(e.target.closest && e.target.closest('details[data-mx-fc]'))) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('details[data-mx-fc][open]');
    if (open) { var s = open.querySelector('summary'); open.removeAttribute('open'); if (s) s.focus(); }
  });

  var timer = 0;
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.hasAttribute && t.hasAttribute('data-cf')) return;
    var form = t.closest('[data-mx-ff]'); if (!form || !t.closest('.mx-fc__p')) return;
    clearTimeout(timer);
    timer = setTimeout(function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }, t.type === 'number' ? 700 : 250);
  });

  /* Keep the footer reachable: Show more appends only after a shopper chooses it.
     Filter-driven requests below still load matching products from real variant data. */
  function watch() {
    var more = document.querySelector('.mx-coll__more');
    if (!more || more.__mxProgress) return;
    more.__mxProgress = 1;
    function syncProgress() {
      var n = more.querySelector('[data-mx-more]');
      if (n && n.textContent === 'Load more') n.textContent = 'Show more';
      var p = more.querySelector('.mx-coll__prog'), sh = more.querySelector('.mx-coll__shown');
      if (p && sh) { var m = sh.textContent.match(/(\d+)\s+of\s+(\d+)/); if (m) p.style.setProperty('--p', (100 * m[1] / m[2]) + '%'); }
    }
    syncProgress();
    if (window.MutationObserver) new MutationObserver(syncProgress).observe(more, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* ---------- Size and Colour chips that work today ----------
     Search & Discovery filters are the right tool and win automatically: this block does nothing when the server already
     returns a Size or Colour filter. Until Bruce adds them in admin, the chips read the quick-add data every card already
     carries (variants: colour, size, in stock), filter the cards on the page, and keep loading the next pages until there are
     enough matches. Nothing is invented: a value exists only if a card has an in-stock variant with it. */
  var SIZE_RANK = { XXS: 0, '2XS': 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, '2XL': 6, XXXL: 7, '3XL': 7, '4XL': 8, '5XL': 9 };
  function sizeKey(v) { var k = String(v).toUpperCase().replace(/\s/g, ''); if (k in SIZE_RANK) return SIZE_RANK[k]; var n = parseFloat(v); return isNaN(n) ? 99 : 100 + n; }
  function cardData(li) {
    if (li.__cd !== undefined) return li.__cd;
    var j = li.querySelector('[data-mx-qa-data]'), d = null;
    if (j) { try { d = JSON.parse(j.textContent); } catch (e) { d = null; } }
    li.__cd = d; return d;
  }
  function initClientFacets() {
    var bar = document.querySelector('[data-mx-fb] .mx-fb__f'), grid = document.querySelector('[data-mx-grid]');
    if (!bar || !grid || bar.__cf) return;
    var haveSize = false, haveColour = false;
    [].forEach.call(bar.querySelectorAll('.mx-fc__s'), function (s) { var t = s.textContent; if (/size/i.test(t)) haveSize = true; if (/colou?r/i.test(t)) haveColour = true; });
    if (haveSize && haveColour) return;
    bar.__cf = 1;
    var sel = { size: {}, colour: {} }, dots = {}, anchor = bar.querySelector('details.mx-fc') || bar.querySelector('.mx-fb__all'), busy = false;
    var note = document.createElement('p'); note.className = 'mx-coll__cfnote'; note.hidden = true; note.setAttribute('role', 'status');
    bar.parentNode.parentNode.insertBefore(note, bar.parentNode.nextSibling);
    function mk(kind, label) {
      var d = document.createElement('details'); d.className = 'mx-fc mx-fc--cf'; d.setAttribute('data-mx-fc', ''); d.setAttribute('data-cf', kind);
      d.innerHTML = '<summary class="ds-chip mx-fc__s">' + label + '<span class="mx-fb__k" hidden></span><svg class="ds-icon ds-icon--chevron-down" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></summary>' +
        '<span class="mx-fc__bd" data-mx-fc-close></span><div class="mx-fc__p mx-fc__p--' + (kind === 'colour' ? 'colour' : 'list') + '" role="group" aria-label="' + label + '"><p class="mx-fc__h">' + label + '</p><div class="mx-fc__vals"></div>' +
        '<div class="mx-fc__foot"><button type="button" class="ds-link" data-cf-clear>Clear</button></div></div>';
      return d;
    }
    var dSize = haveSize ? null : mk('size', 'Size'), dCol = haveColour ? null : mk('colour', 'Colour');
    var ref = anchor && anchor.nextSibling ? anchor.nextSibling : null;
    // order: All filters, Sort, Size, Colour, then the Shopify ones
    var sortD = bar.querySelector('details.mx-fc'); var after = sortD ? sortD.nextSibling : (bar.querySelector('.mx-fb__all') || {}).nextSibling;
    [dSize, dCol].forEach(function (d) { if (d) bar.insertBefore(d, after || null); });
    if (dSize && dCol) bar.insertBefore(dCol, dSize.nextSibling);

    function collect() {
      var sizes = {}, cols = {};
      [].forEach.call(grid.children, function (li) {
        var d = cardData(li); if (!d) return;
        d.v.forEach(function (v) {
          if (!v[3]) return;
          if (v[2]) sizes[v[2]] = (sizes[v[2]] || 0) + 1;
          if (v[1]) { cols[v[1]] = 1; var i = d.c.indexOf(v[1]); if (i >= 0 && d.h && d.h[i]) dots[v[1]] = d.h[i]; }
        });
      });
      return { sizes: Object.keys(sizes).sort(function (a, b) { return sizeKey(a) - sizeKey(b) || (a < b ? -1 : 1); }), cols: Object.keys(cols).sort() };
    }
    function paint(d, kind, vals) {
      var box = d.querySelector('.mx-fc__vals'), have = {};
      [].forEach.call(box.querySelectorAll('input'), function (i) { have[i.value] = 1; });
      vals.forEach(function (v) {
        if (have[v]) return;
        var l = document.createElement('label'); l.className = 'mx-f__o' + (kind === 'colour' ? ' mx-f__o--c' : '');
        var hx = dots[v], pale = hx === '#ffffff' || hx === '#e6edf7';
        l.innerHTML = '<input type="checkbox" data-cf value="' + v.replace(/"/g, '&quot;') + '"' + (sel[kind][v] ? ' checked' : '') + '>' + (kind === 'colour' ? '<i class="mx-f__dot' + (pale ? ' mx-f__dot--pale' : '') + '" style="--sw:' + (hx || '#a3a19c') + '" aria-hidden="true"></i>' : '') + '<span></span>';
        l.querySelector('span').textContent = v;
        box.appendChild(l);
      });
    }
    function refreshOptions() { var c = collect(); if (dSize) paint(dSize, 'size', c.sizes); if (dCol) paint(dCol, 'colour', c.cols); }
    function active() { return Object.keys(sel.size).length + Object.keys(sel.colour).length; }
    function apply() {
      var n = 0, any = active() > 0;
      [].forEach.call(grid.children, function (li) {
        var show = true;
        if (any) {
          var d = cardData(li); show = false;
          if (d) {
            show = d.v.some(function (v) {
              if (!v[3]) return false;
              if (Object.keys(sel.size).length && !sel.size[v[2]]) return false;
              if (Object.keys(sel.colour).length && !sel.colour[v[1]]) return false;
              return true;
            });
          }
        }
        li.hidden = !show; if (show) n++;
      });
      [dSize, dCol].forEach(function (d) {
        if (!d) return; var k = d.getAttribute('data-cf'), c = Object.keys(sel[k]).length, b = d.querySelector('.mx-fb__k');
        b.hidden = !c; b.textContent = c ? ' ' + c : ''; d.querySelector('summary').classList.toggle('is-on', !!c);
      });
      var more = document.querySelector('.mx-coll__more'); if (more) more.classList.toggle('is-cf', any);
      if (!any) { note.hidden = true; return n; }
      var a = document.querySelector('[data-mx-more]');
      note.hidden = false;
      note.innerHTML = '<span></span> <button type="button" class="ds-link" data-cf-clearall>Clear</button>';
      note.firstChild.textContent = n + (n === 1 ? ' piece' : ' pieces') + (a ? ' so far' : '') + ': ' + Object.keys(sel.size).concat(Object.keys(sel.colour)).join(', ');
      return n;
    }
    function more() {
      var a = document.querySelector('[data-mx-more]');
      if (!a || active() === 0) { busy = false; return; }
      var n = grid.querySelectorAll(':scope > li:not([hidden])').length;
      if (n >= 24) { busy = false; return; }
      busy = true; a.click();
    }
    new MutationObserver(function () { refreshOptions(); apply(); if (busy) setTimeout(more, 150); }).observe(grid, { childList: true });
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t.matches || !t.matches('input[data-cf]')) return;
      var k = t.closest('details').getAttribute('data-cf');
      if (t.checked) sel[k][t.value] = 1; else delete sel[k][t.value];
      apply(); more();
    });
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-cf-clear]');
      var ca = e.target.closest && e.target.closest('[data-cf-clearall]');
      if (!c && !ca) return;
      var kinds = ca ? ['size', 'colour'] : [c.closest('details').getAttribute('data-cf')];
      kinds.forEach(function (k) { sel[k] = {}; });
      [].forEach.call(document.querySelectorAll('input[data-cf]'), function (i) { if (kinds.indexOf(i.closest('details').getAttribute('data-cf')) >= 0) i.checked = false; });
      apply();
    });
    refreshOptions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initClientFacets); else initClientFacets();
})();
